import { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setSelectedState } from '@/store/slices/routesSlice'
import { fetchRoutes } from '@/store/slices/routesSlice'
import { INDIAN_STATES } from '@/utils/constants'

export const useMap = () => {
  const dispatch = useDispatch()
  const { selectedState, routes, isLoading, error } = useSelector((state) => state.routes)
  const [mapCenter, setMapCenter] = useState([20.5937, 78.9629]) // India center
  const [mapZoom, setMapZoom] = useState(5)
  const [isFullscreen, setIsFullscreen] = useState(false)

  // Fetch routes on mount
  useEffect(() => {
    dispatch(fetchRoutes())
  }, [dispatch])

  // Re-fetch routes when state selection changes
  useEffect(() => {
    const params = {}
    if (selectedState) {
      params.state = selectedState  // Changed from state_code to state
    }
    dispatch(fetchRoutes(params))
  }, [selectedState, dispatch])

  const handleStateChange = useCallback((stateCode) => {
    dispatch(setSelectedState(stateCode))

    if (stateCode) {
      const state = INDIAN_STATES.find(s => s.code === stateCode)
      if (state) {
        setMapCenter(state.coordinates)
        setMapZoom(7)
      }
    } else {
      setMapCenter([20.5937, 78.9629])
      setMapZoom(5)
    }
  }, [dispatch])

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen(prev => !prev)
  }, [])

  return {
    selectedState,
    mapCenter,
    mapZoom,
    isFullscreen,
    filteredRoutes: routes, // Routes are already filtered by API
    isLoading,
    error,
    handleStateChange,
    toggleFullscreen,
  }
}
